export const SET_SPECIAL_ELIGIBILITY_OPEN = "SET_SPECIAL_ELIGIBILITY_OPEN";
export const SET_SELECTED_SPECIAL_TIMED_AUCTION =
  "SET_SELECTED_SPECIAL_TIMED_AUCTION";
